import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import GalleryViewCard from "./GalleryViewCard";
import ImagePlaceholder from "../ImagePlaceholder";
import {Col, Empty, Row, Skeleton} from "antd";

export function GalleryView(props) {
    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const [loadingData, setLoadingData] = useState(false)
    useEffect(() => {
        setData(props.data)
        setSelectedData(props.selectedData)
        setLoadingData(props.loading ?? false)
    }, [props])

    if (loadingData) {
        return <>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
        </>
    }

    const items = []
    data?.forEach((element, index) => {
        const placeholder = props.imagePlaceholder
        items.push(props.galleryViewItem({
            imagePlaceholder: placeholder({index: index.toString()}),
            index: index,
            ...element,
            element: element,
            aspectRatioKey: props.aspectRatioKey,
            editUrl: props.getEditUrl ? props.getEditUrl(element) : null,
            openUrl: props.getOpenUrl ? props.getOpenUrl(element) : null,
            deleteFunc: props.deleteFunc,
            checked: selectedData.includes(element),
            onCheckChange: props.selectFunc
        }))
    })

    if (data.length === 0) {
        return <Row style={{width: '100%', padding: 64, minHeight: '50vh'}}>
            <Col span={24}
                 style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Empty style={{marginLeft: 'auto', marginRight: 'auto'}}/>
            </Col>
        </Row>
    }

    return (
        <>
            {items}
        </>
    )
}

GalleryView.defaultProps = {
    data: [],
    selectedData: [],
    imagePlaceholder: (props) => {
        return <ImagePlaceholder {...props}/>
    },
    galleryViewItem: (props) => {
        return <GalleryViewCard {...props} />
    },
    selectFunc: null
}

GalleryView.propTypes = {
    data: PropTypes.array,
    selectedData: PropTypes.array,
    imagePlaceholder: PropTypes.func,
    galleryViewItem: PropTypes.func,
    aspectRatioKey: PropTypes.string,
    getEditUrl: PropTypes.func,
    getOpenUrl: PropTypes.func,
    deleteFunc: PropTypes.func,
    selectFunc: PropTypes.func,
}

export default GalleryView